import TrackingStatusReports from 'app/collections/tracking_status_reports';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';
import DropdownSelection from 'app/models/dropdown_selection';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';

import { List as ListView, Heading } from 'app/components/list/list';
import PageHeaderView from 'app/components/page_header';

import countAndPercentHeadingTemplate from './count_and_percent_heading';
import tmpl from './template';

export const CountAndPercentHeading = Base.extend({
  compiledTemplate: countAndPercentHeadingTemplate,

  context() {
    return {
      count: Number(this.model.get('total')).toLocaleString(),
      percent: this.model.get('percent'),
    }
  },
});

export const buildHeadings = () => {
  return [
    new Heading({
      property: 'categoryReadable',
      display: 'Status Category',
      xsSize: 6,
      smSize: 6,
    }),
    new Heading({
      subView: m => new CountAndPercentHeading({ model: m }),
      display: 'Count',
      wrapperClass: 'text-right',
      xsSize: 6,
      smSize: 6,
    }),
  ];
};

export const buildSubItems = () => {
  return {
    property: 'statuses',
    headings: [
      new Heading({
        text: m => m.get('readable'),
        xsSize: 6,
        smSize: 6,
      }),
      new Heading({
        text: m => m.get('count'),
        wrapperClass: 'text-right',
        xsSize: 6,
        smSize: 6,
      }),
    ],
  };
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_orders',

  initialize() {
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATE });

    this.carrierSelection = new DropdownSelection({
      choices: [
        { option: '', readable: 'All Carriers' },
        { option: 'canada_post', readable: 'Canada Post'},
        { option: 'fedex', readable: 'FedEx'},
        { option: 'fedex_smartpost', readable: 'FedEx SmartPost'},
        { option: 'lasership', readable: 'LaserShip'},
        { option: 'ontrac', readable: 'OnTrac'},
        { option: 'ontrac_direct_post', readable: 'OnTrac DirectPost'},
        { option: 'ups', readable: 'UPS'},
        { option: 'ups_mail_innovations', readable: 'UPS Mail Innovations'},
        { option: 'ups_surepost', readable: 'UPS SurePost'},
        { option: 'usps', readable: 'USPS'},
      ],
      label: 'Carrier',
      paramKey: 'carrier',
    });

    this.servicePrioritySelection = new DropdownSelection({
      choices: [
        { option: '', readable: 'All Service Levels' },
        { option: 'standard', readable: 'Standard' },
        { option: 'express', readable: 'Express' },
      ],
      label: 'Service Priority',
      paramKey: 'service_priority',
    });

    this.collection = new TrackingStatusReports([], {
      dateRange: this.dateRange,
      carrierSelection: this.carrierSelection,
      servicePrioritySelection: this.servicePrioritySelection,
    });

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'Tracking Status Report',
    }));
    this.addSubview('carrierPicker', '#carrier_picker', new SelectorView({
      model: this.carrierSelection,
    }));
    this.addSubview('servicePriorityPicker', '#service_priority_picker', new SelectorView({
      model: this.servicePrioritySelection,
    }));
    this.addSubview('datepickers', '#daterange_pickers', new DatepickerRangeView({
      model: this.dateRange
    }));
    this.addSubview('trackingStatusReportList', '#tracking_status_report_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No results.',
      subItems: buildSubItems(),
      columnClasses: 'col-lg-5 col-md-8',
    }));

    this.collection.fetch();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/tracking_status_report/index.js